// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as SendInvoiceRepo from "./SendInvoiceRepo.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";

function SendInvoiceCmp(Props) {
  var orderCrn = Props.orderCrn;
  var orderId = Props.orderId;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = ToastSnackbarHook$Catalyst.useSnackbar(5000, undefined, undefined);
  var openSnackbar = match$1[1];
  var match$2 = React.useState(function () {
        return "";
      });
  var setEmail = match$2[1];
  var email = match$2[0];
  var onSend = function (_event) {
    var recipients = Belt_Array.keep(Belt_Array.map(email.split(","), (function (prim) {
                return prim.trim();
              })), (function (e) {
            return e.length > 0;
          }));
    var allValid = Belt_Array.every(recipients, (function (e) {
            var match = FormValidationUtils$Catalyst.validateEmail(e);
            if (match.TAG === /* Ok */0) {
              return true;
            } else {
              return false;
            }
          }));
    var match = recipients.length;
    if (match === 0) {
      return Curry._1(openSnackbar, {
                  TAG: /* Error */1,
                  _0: "Please enter at least one email"
                });
    }
    if (!allValid) {
      return Curry._1(openSnackbar, {
                  TAG: /* Error */1,
                  _0: "Please enter valid comma-separated emails"
                });
    }
    var id = Belt_Int.fromString(orderId);
    if (id !== undefined) {
      SendInvoiceRepo.sendInvoiceEmail(id, orderCrn, recipients, country).then(function (result) {
              if (result.TAG === /* Ok */0) {
                Curry._1(openSnackbar, {
                      TAG: /* Success */0,
                      _0: "Invoice email sent"
                    });
              } else {
                Curry._1(openSnackbar, {
                      TAG: /* Error */1,
                      _0: "Failed to send invoice email"
                    });
              }
              return Promise.resolve(undefined);
            }).catch(function (param) {
            Curry._1(openSnackbar, {
                  TAG: /* Error */1,
                  _0: "Failed to send invoice email"
                });
            return Promise.resolve(undefined);
          });
      return ;
    } else {
      return Curry._1(openSnackbar, {
                  TAG: /* Error */1,
                  _0: "Invalid order id"
                });
    }
  };
  return React.createElement("div", {
              className: "send-invoice-container"
            }, React.createElement("h1", {
                  className: "send-invoice__title"
                }, "Send Invoice"), React.createElement("div", {
                  className: "send-invoice__hint"
                }, "Multiple Email ID's separated by comma [ , ]"), React.createElement("div", {
                  className: "send-invoice__field"
                }, React.createElement("label", {
                      className: "send-invoice__label"
                    }, "Order ID:"), React.createElement("input", {
                      className: "send-invoice__input",
                      disabled: true,
                      type: "text",
                      value: orderCrn
                    })), React.createElement("div", {
                  className: "send-invoice__field"
                }, React.createElement("label", {
                      className: "send-invoice__label"
                    }, "Enter Email ID:*"), React.createElement("input", {
                      className: "send-invoice__input",
                      placeholder: "Email",
                      type: "text",
                      value: email,
                      onChange: (function ($$event) {
                          var value = $$event.target.value;
                          return Curry._1(setEmail, (function (param) {
                                        return value;
                                      }));
                        })
                    })), React.createElement("button", {
                  className: "send-invoice__send-btn",
                  onClick: onSend
                }, "Send"), match$1[0]);
}

var make = SendInvoiceCmp;

export {
  make ,
  
}
/* react Not a pure module */
